import { render, staticRenderFns } from "./ButtonOptionItem.vue?vue&type=template&id=393d1e52&scoped=true"
import script from "./ButtonOptionItem.vue?vue&type=script&lang=js"
export * from "./ButtonOptionItem.vue?vue&type=script&lang=js"
import style0 from "./ButtonOptionItem.vue?vue&type=style&index=0&id=393d1e52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d1e52",
  null
  
)

export default component.exports